import { render, staticRenderFns } from "./UniPromotion.vue?vue&type=template&id=2ad35fd3&scoped=true"
import script from "./UniPromotion.vue?vue&type=script&lang=js"
export * from "./UniPromotion.vue?vue&type=script&lang=js"
import style0 from "./UniPromotion.vue?vue&type=style&index=0&id=2ad35fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad35fd3",
  null
  
)

export default component.exports